module.exports = require("@bigcommerce/data-store");